import { getAlertsAvailableDates } from "../../../utils";

export const useMinMaxDate = () => {
    const { minDate, maxDate } = getAlertsAvailableDates();

    if (!minDate || !maxDate) {
        throw new Error("Alerts minDate or maxDate is not provided");
    }

    return { minDate, maxDate };
};
